const phoneRegex = /^\+\d{3} \d{2} \d{3} \d{2} \d{2}$/;

const validatePhoneNumber = (number) => {
  return phoneRegex.test(number);
};

export default validatePhoneNumber;
